import { useState, type ReactNode } from "react";
import type { StoreItemType } from "../types";
import { StoreItemContext } from "../contexts/store-item.context";

interface StoreItemProps {
    item: StoreItemType;
    children: ReactNode;
}

export const StoreItemProvider = ({ item, children }: StoreItemProps) => {
    const [state, setState] = useState<string>(null);
    const [error, setError] = useState<string>(null);

    const contextValue = {
        item,
        state,
        setState,
        error,
        setError,
    }

    return <StoreItemContext.Provider value={contextValue}>
        {children}
    </StoreItemContext.Provider>
}